import React, { useMemo } from 'react'
import '../order-detail.scss'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import { IMallOrderDetail } from '../type'
import { ColumnsType } from 'antd/lib/table'
import Big from 'big.js'
import useBemClass from '@/utils/hooks/useBEMClass'
import { Table, Radio, Tooltip } from 'antd'
import { Row } from '@/components/layout/layout'
import Button from '@/components/button/button'
import { useRefund } from '../../../../order-cashier/order-refund/order-refund-confirm'
import Iconfont from '@/components/iconfont/iconfont'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { errorCallBack } from '@/utils'
import $msg from '@/utils/message'

interface MallOrderReplenishProps {
    goodList: IMallOrderDetail.OrderGoodsList[]
    gapPrice: number
    price: number
    payments?: IMallOrderDetail.Payment[]
    orderId: number
    orderType: number
    discountAmount: number
    timeDiscountAmount: number
    refresh?: () => void
}

const MallOrderReplenish: React.FC<MallOrderReplenishProps> = props => {
    const columns: ColumnsType<IMallOrderDetail.OrderGoodsList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'goods',
            width: 180,
            render: (val, r) => <div className={cls('replish-good-name')}>{r.goods_name}</div>,
        },
        {
            title: '售价',
            width: 90,
            key: 'price',
            dataIndex: 'price',
        },
        {
            title: '实配量',
            width: 90,
            key: 'delivered_amount',
            dataIndex: 'delivered_amount',
            render: (v, r) => `+${r.delivered_amount || r.amount}`,
        },
        {
            title: '小计',
            align: 'right',
            width: 90,
            render: (v, r) =>
                `¥${+Big(r.delivered_amount || r.amount)
                    .times(r.price)
                    .round(2)}`,
        },
    ]

    const cls = useBemClass('mall-order-detail')

    const { selectType, setSelectType, paymentType, isOnlinePay } = useRefund(props.payments || [])

    const reweight_goods_list = useMemo(() => {
        return props.goodList.map(item => ({
            order_goods_id: item.order_goods_id,
            delivered_amount: item.delivered_amount || item.amount,
        }))
    }, [props.goodList])

    const refundReq = useRequest(
        () =>
            $post({
                url: '/mall/refundafterreweight',
                params: {
                    order_id: props.orderId,
                    order_type: props.orderType,
                    refund_type: isOnlinePay ? selectType : null,
                    refund_money: +Big(props.gapPrice).abs(),
                    reweight_goods_list: reweight_goods_list,
                    member_discount_amount: props.discountAmount,
                    timed_discount_amount: props.timeDiscountAmount,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '已发送退款通知')
                layerManage.pop()
                props.refresh && props.refresh()
            },
            onError: errorCallBack,
        },
    )

    const supplementReq = useRequest(
        () =>
            $post({
                url: '/mall/supplementafterreweight',
                params: {
                    order_id: props.orderId,
                    order_type: props.orderType,
                    supplement_money: +Big(props.gapPrice).abs(),
                    reweight_goods_list,
                    member_discount_amount: props.discountAmount,
                    timed_discount_amount: props.timeDiscountAmount,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '已发送补款通知')
                layerManage.pop()
                props.refresh && props.refresh()
            },
            onError: errorCallBack,
        },
    )

    return (
        <BaseDialog isShow onClose={() => layerManage.pop()} title="确认配货订单">
            <div
                className={cls('table-container')}
                style={{
                    width: '630px',
                }}
            >
                <Table
                    columns={columns}
                    rowKey={r => r.order_id}
                    dataSource={props.goodList}
                    pagination={false}
                    bordered
                    scroll={{ x: 'max-content', y: 344 }}
                ></Table>

                <div className={cls('table-bottom')}>
                    <span data-color-000 data-font-size-14 data-font-weight-600>
                        实际合计：
                    </span>
                    <span
                        style={{
                            color: '#FF582A',
                        }}
                        data-font-weight-600
                        data-font-size-18
                    >
                        ¥{+Big(props.price).plus(props.gapPrice)}
                    </span>
                    <span className={cls('del-price')}>{props.price}</span>
                    <span className={cls('gap-price')}>
                        (差价:
                        <span
                            style={{
                                color: props.gapPrice > 0 ? '#14CC9B' : 'rgb(255, 88, 42)',
                            }}
                        >
                            {`${props.gapPrice > 0 ? '+' : '-'}`}
                            <span data-font-size-14 data-font-weight-600>
                                ¥{+Big(props.gapPrice).abs()}
                            </span>
                        </span>
                        )
                    </span>
                </div>
            </div>

            {isOnlinePay && (
                <>
                    <Row data-center data-aling-items-center>
                        <div className={cls('line')} />
                        <div data-color-999 data-font-size-16 data-margin-h-8 data-margin-v-15>
                            退款方式
                        </div>
                        <div className={cls('line')} />
                    </Row>
                    <Radio.Group
                        onChange={e => {
                            setSelectType(e.target.value)
                        }}
                        value={selectType}
                    >
                        <Row className={cls('group')} data-align-items-center data-padding-left-16>
                            {paymentType.map(p => (
                                <div key={p.id} className={cls('radio-container')} data-align-items-center>
                                    <Radio value={p.id}>{p.name}</Radio>
                                    {p.des && (
                                        <Tooltip placement="topLeft" trigger={['click', 'hover']} title={p.des}>
                                            <Iconfont
                                                name="icon8yiwen-16"
                                                size={16}
                                                style={{
                                                    marginLeft: '-6px',
                                                    zIndex: 10,
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                </div>
                            ))}
                        </Row>
                    </Radio.Group>
                </>
            )}
            <Row data-align-items-center data-width-100p data-justify-content-flex-end data-padding-16>
                <Button
                    loading={refundReq.loading || supplementReq.loading}
                    disabled={isOnlinePay && selectType === -1}
                    types="default"
                    onClick={() => {
                        if (props.gapPrice > 0) {
                            supplementReq.run()
                        } else {
                            refundReq.run()
                        }
                    }}
                >
                    确认{props.gapPrice > 0 ? '补款' : '退款'}
                </Button>
            </Row>
        </BaseDialog>
    )
}

export default MallOrderReplenish
